import * as ActionTypes from "./actionTypes"
import * as UserDataActions from '../../../panels/user/userData/actions'
import {managementAssignmentsCountsLoadSuccess, setUserManagementAssignmentsSelection} from '../../../panels/user/userData/actions'
import {convertManagementAssignmentsDataFromRpc, convertUserAccessRightsDataFromRpc} from '../../../panels/user/utils'
import {setUpdatingData} from '../../../panels/user/editPanel/actions'
import * as SyncCallbacks from '../../../panels/user/editPanel/syncCallbacks'
import {getCopyUserFrom, getManagementAssignmentsSelection, getPanelUser, getTab, getUserId} from './selectors'
import rpcCall, {abortCall} from '../../../util/rpc/rpcCalls'
import actionsGenerator from '../hierarchyAssignmentsPanelTab/actionsGenerator'
import {addCustomers, addProjects, addTasks, addTimeZoneGroups, addUser, addUserGroups, removeUser} from '../../../entities/actions'
import {HierarchyLevels, ManagementAssignmentsSelection} from 'constants'
import {closeAllPanels, handleCommonError, setUserManagementData, setViewerManagementAssignmentsCounters} from '../common/actions'
import messageResource from '../../../messageResource'
import {getCustomer, getProject, getTask} from '../../../entities/selectors'
import {toast} from '../../../toasts/actions'
import {updateWorkAssignmentsCounters} from '../managementAssignmentsEditor/actions'
import {arrayToSet} from '../../../atUtils'
import {isWASEnabled} from '../../../features/selectors'
import {createAction} from 'redux-actions'
import {updateFeatures} from '../../../features/actions'
import {batched} from '../../../redux/batch'
import {isAborted} from '../../../util/rpc/rpcUtils'
import {setWorkAssignmentsCountersForUser} from '../workAssignmentsTab/actions'
import {EXCEPTIONS} from '../../../panels/user/editPanel/util'
import {handleCommonExceptions} from '../common/utils'
import {Exceptions} from '../../../panels/user/editTeamAssignmentsPanel/constants'
import {Exceptions as CommonExceptions} from '../../../common/constants'

const GET_VIEW_USER_MANAGEMENT_ASSIGNMENTS_METHOD = 'UserManagementService.getViewUserManagementAssignments'

const hierarchyAssignmentsTabActions = actionsGenerator({
    actionTypes: ActionTypes
})

export const setTaskIds = hierarchyAssignmentsTabActions.setTaskIds

export const setProjectIds = hierarchyAssignmentsTabActions.setProjectIds

export const setCustomerIds = hierarchyAssignmentsTabActions.setCustomerIds

export const setUserId = hierarchyAssignmentsTabActions.setUserId

export const setTab = hierarchyAssignmentsTabActions.setTab

export const setManageTaskIds = hierarchyAssignmentsTabActions.setManageTaskIds

export const setManageProjectIds = hierarchyAssignmentsTabActions.setManageProjectIds

export const setManageExcludingSelfProjectIds = hierarchyAssignmentsTabActions.setManageExcludingSelfProjectIds

export const setManageCustomerIds = hierarchyAssignmentsTabActions.setManageCustomerIds

export const setManageExcludingSelfCustomerIds = hierarchyAssignmentsTabActions.setManageExcludingSelfCustomerIds

export const setUserCounters = hierarchyAssignmentsTabActions.setUserCounters

export const setTaskTabLoaded = hierarchyAssignmentsTabActions.setTaskTabLoaded

export const setProjectTabLoaded = hierarchyAssignmentsTabActions.setProjectTabLoaded

export const setCustomerTabLoaded = hierarchyAssignmentsTabActions.setCustomerTabLoaded

export const setSearchString = hierarchyAssignmentsTabActions.setSearchString

export const setSearchOpen = hierarchyAssignmentsTabActions.setSearchOpen

export const setLoading = hierarchyAssignmentsTabActions.setLoading

export const setLoaded = hierarchyAssignmentsTabActions.setLoaded

export const openPanel = hierarchyAssignmentsTabActions.openPanel

export const clearTabsLoaded = hierarchyAssignmentsTabActions.clearTabsLoaded

export const setIsShowArchiveEntities = hierarchyAssignmentsTabActions.setIsShowArchiveEntities

const openCopyContent = createAction(ActionTypes.COPY_CONTENT_OPEN)

const closeCopyContent = createAction(ActionTypes.COPY_CONTENT_CLOSE)

export const setCopyUserId = createAction(ActionTypes.COPY_USER_ID_SET)

export const setCopyLoading = createAction(ActionTypes.COPY_LOADING_SET)

export const setCopyCounters = createAction(ActionTypes.COPY_COUNTERS_SET)

export const setCopySelectorUsers = createAction(ActionTypes.COPY_USER_IDS_FOR_SELECTOR_SET)

const resetSearch = hierarchyAssignmentsTabActions.resetSearch

export const changeManagementAssignmentsSelection = (managementAssignmentsSelection) => (dispatch, getState) => {
    dispatch(setUpdatingData(true))
    const editUserId = getUserId(getState())
    const prevManagementAssignmentsSelection = getManagementAssignmentsSelection(getState())
    const isWAFeatureEnabled = isWASEnabled(getState())

    rpcCall("UserManagementService.changeUserManagementAssignmentsSelection", [editUserId, managementAssignmentsSelection],
        rpcError => handleCommonExceptions(rpcError))
        .then(data => {
            const userInfo = data.userInfo;

            const userManagementData = {
                viewerSettings: data.viewerSettings,
            }
            if (data.userGroups) {
                userManagementData.allUserGroups = data.userGroups
            }
            if (data.timeZoneGroups) {
                userManagementData.allTimeZoneGroups = data.timeZoneGroups
            }

            dispatch(setUserManagementData(userManagementData))

            dispatch(UserDataActions.setFullUserInfo({
                ...userInfo,
                accessRights: convertUserAccessRightsDataFromRpc(userInfo),
            }))

            dispatch(addUser(userInfo))
            dispatch(updateWorkAssignmentsCounters(data))

            dispatch(setUpdatingData(false))
            dispatch(UserDataActions.setUserManageAssignmentsData(convertManagementAssignmentsDataFromRpc(data.additionalResultData.map['manageAssignmentsData'])))
            SyncCallbacks.onUpdateUserData(data)

            if ((managementAssignmentsSelection === ManagementAssignmentsSelection.NO ||
                (managementAssignmentsSelection === ManagementAssignmentsSelection.SELECTED &&
                 prevManagementAssignmentsSelection === ManagementAssignmentsSelection.ALL)) && isWAFeatureEnabled) {
                dispatch(toast(messageResource.getMessage('user_list.toasts.revoke_all_management_scope')))
            }
        })
        .catch(error => {
            dispatch(handleCommonError(editUserId, error))
            dispatch(setUpdatingData(false))
            dispatch(UserDataActions.addUserPanelErrors([error._providerStatus]));
        })
}

export const changeAssignmentPanelTab = (tab) => (dispatch, getState) => {
    dispatch(closeCopyContent())
    const prevTab = getTab(getState())
    if (prevTab !== tab) {
        dispatch(resetSearch())
        dispatch(setTab(tab))
    }
}

export const openManagementAssignmentPanel = (id, tab) => (dispatch, getState) => {
    if (id === null)
        return

    const prevId = getUserId(getState())
    const prevTab = getTab(getState())
    if (id !== prevId) {
        dispatch(cancelLoadData())
        dispatch(openPanel({userId: id, tab: tab}))
    } else if (tab !== prevTab) {
        dispatch(setTab(tab))
    } else {
        dispatch(closePanel())
    }
}

const cancelLoadData = () => dispatch => {
    abortCall(GET_VIEW_USER_MANAGEMENT_ASSIGNMENTS_METHOD)
    dispatch(setLoaded(true))
    dispatch(setCustomerTabLoaded(true))
    dispatch(setProjectTabLoaded(true))
    dispatch(setTaskTabLoaded(true))
}

export const closePanel = () => dispatch => {
    abortCall(GET_VIEW_USER_MANAGEMENT_ASSIGNMENTS_METHOD)
    dispatch(hierarchyAssignmentsTabActions.closePanel())
    dispatch(closeCopyContent())
}

export const prepareLoadedData = (data, tabType) => (dispatch) => {
    dispatch(addCustomers(data.customers))
    dispatch(addProjects(data.projects))
    dispatch(addTasks(data.tasks))

    dispatch(managementAssignmentsCountsLoadSuccess(data.userCounter))
    dispatch(setUserCounters(data.userCounter))
    dispatch(setViewerManagementAssignmentsCounters(data.viewerCounter))

    const maCptIds = data.managementAssignmentsCptIds

    dispatch(setManageTaskIds(arrayToSet(maCptIds.taskIds)))
    dispatch(setManageProjectIds(arrayToSet(maCptIds.projectIds)))
    dispatch(setManageExcludingSelfProjectIds(arrayToSet(maCptIds.projectIdsExcludingSelf)))
    dispatch(setManageCustomerIds(arrayToSet(maCptIds.customerIds)))
    dispatch(setManageExcludingSelfCustomerIds(arrayToSet(maCptIds.customerIdsExcludingSelf)))

    switch (tabType) {
        case HierarchyLevels.TASK:
            dispatch(setTaskIds(data.taskIds))
            dispatch(setTaskTabLoaded(true))
            break
        case HierarchyLevels.PROJECT:
            dispatch(setProjectIds(data.projectIds))
            dispatch(setProjectTabLoaded(true))
            break
        case HierarchyLevels.CUSTOMER:
            dispatch(setCustomerIds(data.customerIds))
            dispatch(setCustomerTabLoaded(true))
            break
    }
    dispatch(setLoaded(true))
}

export const loadManagementAssignmentPanelDataAction = () => (dispatch, getState) => {
    const userId = getUserId(getState())
    const tabType = getTab(getState())
    dispatch(setLoading(true))
    rpcCall(GET_VIEW_USER_MANAGEMENT_ASSIGNMENTS_METHOD, [userId, tabType],
        rpcError => handleCommonExceptions(rpcError))
        .then(batched(data => {
            dispatch(prepareLoadedData(data.viewAssignmentsData, tabType))
            dispatch(setWorkAssignmentsCountersForUser(userId, data.userWorkAssignmentsCounters))
            dispatch(setUserManagementAssignmentsSelection(data.managementAssignmentsSelection))
            dispatch(setLoading(false))
        }))
        .catch((err) => {
            if (isAborted(err)) return

            dispatch(setLoading(false))
            dispatch(handleCommonError(userId, err))
            dispatch(closePanel())
        })
}

export const revokeAllTypeAction = () => (dispatch, getState) => {
    const userId = getUserId(getState())
    const type = getTab(getState())
    dispatch(setLoading(true))

    const isWAFeatureEnabled = isWASEnabled(getState())

    rpcCall('UserManagementService.revokeAllManagementAssignment', [userId, type],
        rpcError => handleCommonExceptions(rpcError))
        .then((data) => {
            dispatch(prepareLoadedData(data.additionalResultData.map['manageAssignmentsData'], type))
            dispatch(setLoading(false))
            SyncCallbacks.onUpdateUserData(data)
            if (isWAFeatureEnabled)
                dispatch(toast(getAllEntitiesRevokedMessage(type)))
        })
        .catch((error) => {
            dispatch(setLoading(false))
            dispatch(handleCommonError(userId, error))
        })
}

export const revokeEntitiesAction = (revokeEntityLevel, id) => (dispatch, getState) => {
    const userId = getUserId(getState())
    const typeTab = getTab(getState())
    dispatch(setLoading(true))

    const isWAFeatureEnabled = isWASEnabled(getState())

    rpcCall('UserManagementService.revokeEntityManagementAssignment', [userId, typeTab, id, revokeEntityLevel],
        rpcError => handleCommonExceptions(rpcError))
        .then((data) => {
            dispatch(prepareLoadedData(data.additionalResultData.map['manageAssignmentsData'], typeTab))
            dispatch(setLoading(false))
            SyncCallbacks.onUpdateUserData(data)

            // TODO bakharev: what if typeTab != revokeEntityLevel
            if (isWAFeatureEnabled)
                dispatch(toast(getEntityRevokedMessage(getState, revokeEntityLevel, id)))
        })
        .catch((error) => {
            dispatch(setLoading(false))
            dispatch(handleCommonError(userId, error))
        })
}

export const showCopyContent = () => (dispatch) => {
    dispatch(openCopyContent())
    dispatch(loadCopyManagementAssignmentSelectorUsers())
}

export const cancelCopy = () => (dispatch) => {
    dispatch(closeCopyContent())
}

export const loadUserCounters = (userId) => (dispatch) => {
    dispatch(setCopyLoading(true))
    rpcCall('UserManagementService.getUserManagementAssignmentsCounters', [userId],
        rpcError => handleCommonExceptions(rpcError))
        .then(batched(data => {
            dispatch(setCopyCounters(data))
            dispatch(setCopyUserId(userId))
            dispatch(setCopyLoading(false))
        }))
        .catch((error) => {
            dispatch(handleCommonError(userId, error))
            dispatch(setCopyLoading(false))
        })

}

export const loadCopyManagementAssignmentSelectorUsers = () => (dispatch) => {
    dispatch(setCopyLoading(true))
    rpcCall('UserManagementService.getUserSelectorData', [],
        rpcError => handleCommonExceptions(rpcError))
        .then(batched((data) => {
            dispatch(setCopyLoading(false))
            dispatch(updateFeatures(
                {
                    UGR: data.ugrEnabled,
                    TZG: data.tzgEnabled,
                }
            ))
            dispatch(addTimeZoneGroups(data.timeZoneGroups))
            dispatch(addUserGroups(data.userGroups))
            dispatch(setCopySelectorUsers(data.users))
        }))
        .catch((error) => {
            dispatch(setCopyLoading(false))
        })
}

export const copyAssignments = () => (dispatch, getState) => {
    const state = getState()
    const userTo = getPanelUser(state)
    const userFrom = getCopyUserFrom(state)

    dispatch(setCopyLoading(true))
    rpcCall('UserManagementService.copyManagementAssignmentsFrom', [userTo.id, userFrom.id],
        rpcError => {
            rpcError.handleOnExceptions([...Object.values(Exceptions), CommonExceptions.USER_HAS_NO_ACCESS_TO_SCOPE_EXCEPTION])
            handleCommonExceptions(rpcError)
        })
        .then(batched((data) => {
            dispatch(toast(messageResource.getMessage('management_assignment.panel.copy.toast.settings_copied', [userTo.firstName, userFrom.firstName])))
            dispatch(setCopyLoading(false))
            dispatch(closeCopyContent())
            dispatch(setCustomerTabLoaded(false))
            dispatch(setProjectTabLoaded(false))
            dispatch(setTaskTabLoaded(false))
            dispatch(addUser(data.userInfo))
        }))
        .catch((error) => {
            dispatch(handleCommonError(userTo.id, error))
            switch (error.getException()) {
                case Exceptions.NoSuchUserException:
                    dispatch(closeAllPanels())
                    break
                case Exceptions.NoSuchCopyUserException:
                    alert(messageResource.getMessage('work_assignments.panel.copy.error.user_deleted'))
                    dispatch(removeUser(userFrom.id))
                    SyncCallbacks.onNoSuchUserException(userFrom.id)
                    break
                case Exceptions.UserHasAccessToAllScopeException:
                    alert(messageResource.getMessage('management_assignment.error.copy.user_to_has_entire_scope'))
                    window.location.reload()
                    break
                case CommonExceptions.USER_HAS_NO_ACCESS_TO_SCOPE_EXCEPTION:
                    alert(messageResource.getMessage('management_assignment.error.copy.user_to_has_no_access'))
                    window.location.reload()
                    break
                default:
                    console.error(error)
                    dispatch(closeCopyContent())
            }
            dispatch(setCopyLoading(false))
        })
}

const getEntityRevokedMessage = (getState, entityType, entityId) => {
    let name
    switch (entityType) {
        case HierarchyLevels.CUSTOMER:
            name = getCustomer(getState(), entityId).name
            return messageResource.getMessage('user_list.toasts.revoke_manage_customer_from_user', [name])
        case HierarchyLevels.PROJECT:
            name = getProject(getState(), entityId).name
            return messageResource.getMessage('user_list.toasts.revoke_manage_project_from_user', [name])
        case HierarchyLevels.TASK:
            name = getTask(getState(), entityId).name
            return messageResource.getMessage('user_list.toasts.revoke_manage_task_from_user', [name])
    }
    return ''
}

const getAllEntitiesRevokedMessage = (entityType) => {
    switch (entityType) {
        case HierarchyLevels.CUSTOMER:
            return  messageResource.getMessage('user_list.toasts.revoke_all_customers.view_management_scope')
        case HierarchyLevels.PROJECT:
            return  messageResource.getMessage('user_list.toasts.revoke_all_projects.view_management_scope')
        case HierarchyLevels.TASK:
            return messageResource.getMessage('user_list.toasts.revoke_all_tasks.view_management_scope')
    }
    return ''
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/editManagementAssignmentsPanel/actions.js